import { message, type Payloads } from "@/utilities/message/message";
import { err, ok } from "@/utilities/result";

type CashoutBetPayload = Payloads["cashout-bet"];

const confirmCashOut = async (payload: CashoutBetPayload) => {
  const [response, error] = await message("cashout-bet", payload);

  if (error) {
    return err(error);
  }

  return ok(response);
};

export { confirmCashOut };
